import glam from 'glamorous';
import { GridUtils } from 'module/Common';

export type AbsolutePosProps = {
  cardCoords: GridUtils.Coordinates;
  transition?: boolean;
};

export const AbsolutePos = glam.div<AbsolutePosProps>(({ transition = true, cardCoords }) => ({
  position: 'absolute',
  ...(transition ? { transition: 'transform 0.3s 0.1s' } : {}),
  overflow: 'hidden',
  transform: `translateX(${cardCoords.left}px) translateY(${cardCoords.top}px) translateZ(0px) !important`,
  width: cardCoords.width,
  height: cardCoords.height,
  left: 0,
  top: 0,
}));



// WEBPACK FOOTER //
// ./src/module/View/Common/component/AbsolutePos/index.tsx